export default __webpack_public_path__ + "static/media/20.bfda8b99.png";